import React, { useEffect, useState } from 'react'
import { IAdFaq } from '../interfaces/AdFaq';
import IPageProps from '../interfaces/page'
import { handleLink } from '../modules/utils';
import { getAdFaq, getAdFaqByKeyword } from '../services/AdFaqService';
import FooterPage from './footer';
import TopNavPage1 from './topNav1';

const FaqPage: React.FunctionComponent<IPageProps> = props => {
    const [adFaq,setAdFaq]=useState<IAdFaq[]>([])
    const [isFetched,setIsFetched]=useState(false);
    let typeidx=0
    useEffect(()=>{
        const fetchData=async()=>{
            const response=await getAdFaq('讀寫練習');
            setAdFaq(response);
            setIsFetched(true);
        }
        fetchData();
    },[])

    
    if(isFetched)
    {
    return (
        <>
            <TopNavPage1/>
            <div className="section pt-3">
                <div className="container px-3 px-md-4">
                    <div className="d-flex align-items-center justify-content-between flex-column flex-md-row">
                        <h5 className="mb-3">常見問題<small className="ms-2">Q&A</small></h5>
                    </div>
                    <div className="accordion mt-4">
                        <div className="card p-2">
                            {
                                adFaq.map((item,index)=>{
                                    if((index===0) || (item.Type!==adFaq[index-1].Type))
                                    {
                                        typeidx++;
                                        return <>
                                                    <div className="alert alert-blue mb-0">
                                                        <button className="accordion-button p-0" type="button" data-bs-toggle="collapse" data-bs-target={"#level"+typeidx.toString().trim()}
                                                        aria-expanded="true" aria-controls={"level"+typeidx.toString().trim()}>
                                                        <div style={{color:'#116e71'}}>{item.Type}</div>
                                                        <i className="collapse-close fas fa-angle-down pt-1 position-absolute end-0 fs-22" aria-hidden="true"></i>
                                                        <i className="collapse-open fas fa-angle-up pt-1 position-absolute end-0 fs-22" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                    <div className="collapse pt-3 collapse show" id={"level"+typeidx.toString().trim()} data-bs-parent="#accordionRental">
                                                        <div className="qaq">
                                                            <span>Q.{index}{item.Question}</span>
                                                        </div>
                                                        <div className="qaa text-start">
                                                            {item.Answer}
                                                        </div>
                                                    </div>
                                                </>                                        
                                    }
                                    else
                                    {
                                    return <div className="collapse pt-3 collapse show"  id={"level"+(typeidx).toString().trim()} data-bs-parent="#accordionRental">
                                                <div className="qaq">
                                                    <span>Q.{index}{item.Question}</span>
                                                </div>
                                                <div className="qaa text-start">
                                                    {item.Answer}
                                                </div>
                                    
                                            </div>
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <FooterPage/>
        </>
        
    );
    }
    else
    {
        return <div><h3>Loading</h3></div>;
    }
}

export default FaqPage;